// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"TQ-z","categoryName":"UQ-z","categoryNameSearchHeader":"VQ-z","categoryContent":"WQ-z","bottomAligned":"XQ-z","image":"YQ-z","imageNoBackground":"ZQ-z"};